import { createFileRoute } from '@tanstack/react-router'
import { BasicSectionPage } from '@/features/setup/basic-section-page'

export const Route = createFileRoute('/_auth/w/$workspaceSlug/setup/basic')({
  component: BasicSectionRoute,
})

function BasicSectionRoute() {
  const { workspaceSlug } = Route.useParams()

  return <BasicSectionPage workspaceSlug={workspaceSlug} />
}
